// plugins/first-test-plugin/src/components/AwesomeUsersTable.tsx
import React from 'react';
import useAsync from 'react-use/esm/useAsync';

export const AwesomeUsersTable = () => {
  const { value, loading, error } = useAsync(async () => {
    const response = await fetch('https://jsonplaceholder.typicode.com/posts');
    return response.json();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div>
      <h2>Posts from JSONPlaceholder</h2>
      <ul>
        {value?.map((post: any) => (
          <li key={post.id}>{post.title}</li>
        ))}
      </ul>
    </div>
  );
};

